import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Menu from './components/Menu';
import Bienvenida from './components/Bienvenida';
import Ventas from './components/Ventas';
import Inventario from './components/Inventario';
import Pedidos from './components/Pedidos';
import Reportes from './components/Reportes';
import Carrito from './components/Carrito';
import Cotizaciones from './components/Cotizaciones';
import Usuarios from './components/Usuarios';
import { CarritoProvider } from './context/CarritoContext';
import { NotificacionesProvider } from './context/NotificacionesContext';
import usuariosDemo from './data/usuariosDemo';

function App() {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Cargar usuario desde localStorage al iniciar
  useEffect(() => {
    const usuarioGuardado = localStorage.getItem('usuario');
    if (usuarioGuardado) {
      try {
        setUsuario(JSON.parse(usuarioGuardado));
      } catch (error) {
        console.error('Error al cargar usuario:', error);
        localStorage.removeItem('usuario');
      }
    }
    setCargando(false);
  }, []);

  // Función para actualizar usuario y guardarlo en localStorage
  const actualizarUsuario = (nuevoUsuario) => {
    if (nuevoUsuario) {
      localStorage.setItem('usuario', JSON.stringify(nuevoUsuario));
      setUsuario(nuevoUsuario);
    } else {
      localStorage.removeItem('usuario');
      setUsuario(null);
    }
  };

  return (
    <CarritoProvider>
      <NotificacionesProvider>
        <Router>
          <Menu usuario={usuario} setUsuario={actualizarUsuario} />
          {cargando ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <p>Cargando...</p>
            </div>
          ) : (
            <Routes>
              <Route path="/login" element={<Login setUsuario={actualizarUsuario} />} />
              <Route path="/" element={usuario ? <Bienvenida usuario={usuario} /> : <Navigate to="/login" />} />
              <Route path="/ventas" element={usuario ? <Ventas usuario={usuario} /> : <Navigate to="/login" />} />
              <Route path="/inventario" element={usuario ? <Inventario usuario={usuario} /> : <Navigate to="/login" />} />
              <Route path="/pedidos" element={usuario ? <Pedidos usuario={usuario} /> : <Navigate to="/login" />} />
              <Route path="/carrito" element={usuario ? <Carrito usuario={usuario} /> : <Navigate to="/login" />} />
              <Route path="/reportes" element={usuario ? <Reportes usuario={usuario} /> : <Navigate to="/login" />} />
              <Route path="/cotizaciones" element={usuario ? <Cotizaciones usuario={usuario} /> : <Navigate to="/login" />} />
              <Route path="/usuarios" element={usuario ? <Usuarios usuario={usuario} /> : <Navigate to="/login" />} />
            </Routes>
          )}
        </Router>
      </NotificacionesProvider>
    </CarritoProvider>
  );
}

export default App;
